"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
exports.default = react_jss_1.createUseStyles({
    tabs: function (_a) {
        var theme = _a.theme;
        return ({
            borderBottom: "2px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[3]),
        });
    },
    tabsInner: {
        marginBottom: -2,
    },
    body: function (_a) {
        var theme = _a.theme;
        return ({
            paddingTop: theme.spacing.sm,
        });
    },
}, { link: true });
